import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M10 9.375a2.708 2.708 0 1 0 0-5.417 2.708 2.708 0 0 0 0 5.417Zm-4.294 6.667h8.588c.951 0 1.684-.819 1.24-1.66-.654-1.238-2.144-2.715-5.534-2.715-3.39 0-4.88 1.477-5.534 2.715-.444.841.289 1.66 1.24 1.66Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);